import { useState, useEffect } from 'react';
import { useFirestoreConnect } from 'react-redux-firebase';
import { isLoaded } from 'react-redux-firebase';
import { useSelector } from 'react-redux';
import { isEmpty } from 'react-redux-firebase';

export default function useVendor() {
    const [isLoading, setIsLoading]= useState(false);
    const getVendor = useSelector(state => state.firestore.ordered['vendors']);
    
    useFirestoreConnect(()=>[
        {collection:'vendors', storeAs: 'vendors'}
    ]);

    useEffect(() => {
        if(!isLoaded(getVendor)){
            setIsLoading(true);
        }else{
            setIsLoading(false);
        }
    },[getVendor])

    const vendors = !isEmpty(getVendor) ? getVendor: []
    let sortVendor = [...vendors];
    sortVendor.sort((a, b) =>{
        if(a.Name < b.Name)
            return -1
        if(a.Name > b.Name)
            return 1
        return 0
    }) 

    return { vendors: sortVendor, isLoading }
}
